@if (cities.length > 1) {
<div class="city-selector-wrapper me-2 header-item d-flex align-items-center">
  <ng-select
    class="dp-themed-select city-selector"
    style="min-width: 150px"
    [ngModel]="selectedId"
    (ngModelChange)="onChange($event)"
    [searchable]="false"
    [clearable]="false"
  >
    @for (c of cities; track c._id) {
    <ng-option [value]="c._id">{{ c.name }}</ng-option>
    }
  </ng-select>
</div>
}
